import { Flex } from 'foundations-components/components/Flex';
import { FilterPopover } from './TicketListingsFilterPopover';
import { TicketListingsSortPopover } from './TicketListingsSortPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InboxNavSortAndFilter() {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FilterPopover, {
      placement: "bottom right"
    }), /*#__PURE__*/_jsx(TicketListingsSortPopover, {
      placement: "bottom right"
    })]
  });
}